<template>
    <div class="featured-grid-skeleton w-full">
        <div class="d-flex align-items-center justify-content-between mb-2">
            <div class="section-title"></div>
        </div>
        <div class="featured-grid-skeleton-inner clearfix"  v-if="!isShowSteketonMd && !isShowSteketonSm">
            <div v-for="index in this.quantity || 10" :key="index" class="featured-item-skeleton">
            </div>
        </div>
   
        <div class="featured-grid-skeleton-inner clearfix" v-if="isShowSteketonMd">
            <div v-for="index in 4" :key="index" class="featured-item-skeleton">
            </div>
        </div>

        <div class="featured-grid-skeleton-inner clearfix" v-if="isShowSteketonSm">
            <div v-for="index in 2" :key="index" class="featured-item-skeleton">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isShowSteketonMd: false,
            isShowSteketonSm: false,
        };
    },
    props: ['quantity'],
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize);
    },
    methods: {
       handleResize() {
            if (parseInt(window.innerWidth) <= 576) {
                this.isShowSteketonSm = true;
                this.isShowSteketonMd = false;
            } else if (576 < parseInt(window.innerWidth) && parseInt(window.innerWidth) <= 991) {
                this.isShowSteketonSm = false;
                this.isShowSteketonMd = true;
            } else {
                this.isShowSteketonSm = false;
                this.isShowSteketonMd = false;
            }
        },
    },
};
</script>
